const JSON_HEADER = 'application/json';

export class HttpError extends Error {
  readonly status: number;

  constructor(status: number, statusText: string, body: string) {
    super(`HTTP Error: ${status} - ${statusText} : ${body}`);
    this.status = status;
    // Required for correct instanceof checks when compiled to ES5
    Object.setPrototypeOf(this, HttpError.prototype);
  }
}

async function execRequest(url: string, config: RequestInit = {}): Promise<{ body: string; headers: Headers }> {
  const response = await fetch(url, config);
  if (!response.ok) {
    const { status, statusText } = response;
    const text = await response.text();
    throw new HttpError(status, statusText, text);
  }

  const body = await response.text();
  return { body, headers: response.headers };
}

export function postData(
  url: string,
  payload: unknown,
  config?: RequestInit,
): Promise<{ body: string; headers: Headers }> {
  const postConfig: RequestInit = {
    ...config,
    headers: {
      ...(config?.headers || {}),
      'Content-Type': JSON_HEADER,
    },
    method: 'POST',
    body: JSON.stringify(payload),
  };

  return execRequest(url, postConfig);
}
